/**
 * Recalcule les autoTags d'un exercice stocké (même logique que SaveExerciseModal / exerciseService).
 * Module pur (pas de Firebase) — utilisable depuis les scripts Node de migration.
 */

import { sanitizeAutoTags } from '../data/knownTags'
import { generateAutoTags, getHorizonsTagsForCategory, getDecadeTag, getEraTagForExercise } from './tagGenerator'
import {
  getFormationTag,
  getGenreTag,
  mergeFormationIdsFromReferenceAndTitle,
  CLASSICAL_FORMATIONS,
  HORIZONS_FORMATIONS
} from '../data/formations'
import { getComposerDisplayName } from './exerciseDisplay'

/**
 * @param {Object} exercise - Exercice avec markers, metadata
 * @returns {string[]}
 */
export function computeAutoTagsForStoredExercise(exercise) {
  if (!exercise || !Array.isArray(exercise.markers)) return []
  const chordData = {}
  exercise.markers.forEach((m, i) => {
    if (m && m.chord) chordData[i] = m.chord
  })
  const markers = exercise.markers
  const composer = getComposerDisplayName(exercise.metadata)?.trim() || null
  const generated = generateAutoTags(markers, chordData, composer)

  const section = exercise.metadata?.section
  const musicCategory = exercise.metadata?.musicCategory
  const year = exercise.metadata?.year
  const formationRaw = exercise.metadata?.formation
  const formationArrRaw = Array.isArray(formationRaw) ? formationRaw : formationRaw ? [formationRaw] : []
  const genre = exercise.metadata?.genre || null
  const isHorizons = section === 'horizons'
  const validFormationIds = new Set((isHorizons ? HORIZONS_FORMATIONS : CLASSICAL_FORMATIONS).map((f) => f.id))
  const normalizedFormation = formationArrRaw.filter((id) => validFormationIds.has(id))
  // Dès qu’au moins une formation valide est enregistrée, on ne réinfère pas depuis le titre au recalcul
  // (bouton régénérer / refresh) — évite d’écraser une correction manuelle (ex. sérénade orchestrale).
  const formationArr =
    normalizedFormation.length > 0
      ? normalizedFormation
      : mergeFormationIdsFromReferenceAndTitle(
          [],
          exercise.metadata?.workTitle || '',
          isHorizons ? 'horizons' : null,
          genre,
          (id) => validFormationIds.has(id)
        )

  const horizonsTags = section === 'horizons' && musicCategory ? getHorizonsTagsForCategory(musicCategory) : []
  const decadeTag = section === 'horizons' && year != null ? getDecadeTag(year) : null
  const eraTag = section === 'horizons' && musicCategory && year != null ? getEraTagForExercise(musicCategory, year) : null
  const formationTags = formationArr.map((id) => getFormationTag(id)).filter(Boolean)
  const genreTag = genre ? getGenreTag(genre) : null

  const autoTags = [
    ...horizonsTags,
    ...(decadeTag ? [decadeTag] : []),
    ...(eraTag ? [eraTag] : []),
    ...formationTags,
    ...(genreTag ? [genreTag] : []),
    ...generated
  ]
  return sanitizeAutoTags([...new Set(autoTags)])
}
